<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1">I would like to dedicate this book to all my patients and<br/> readers and to members of my <a href="http://Self-Coaching.net" target="_blank">Self-Coaching.net</a> community.<br/> You have been my inspiration, my encouragement, and my<br/> motivation to continue on my path.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// luci_9780470893708_oeb_ded_r1.vue?156c5fde